import React, { useContext, useEffect, useState } from "react";
import Form from "../../../components/form";
import cfe from "../../../services/cfe";
import AppContext from "../../../container/context";

export default function Inserir(props) {
  const [dados, setDados] = useState({});
  const { notification } = useContext(AppContext);
  const [instituicoes, setInstituicoes] = useState([]);
  const history = props.history;

  useEffect(() => {
    carregarInstituicoes();
  }, []);

  const carregarInstituicoes = () => {
    cfe
      .get("admin/instituicoes/listar")
      .then((res) => {
        setInstituicoes(res);
      })
      .catch((e) => notification("error", "Erro ao listar os instituições"));
  };

  const salvar = (form) => {
    setDados(form);

    cfe
      .put("admin/tokensCadastro/inserir", form)
      .then((res) => {
        notification("success", "Token inserido com sucesso");
        history.goBack();
      })
      .catch((err) => {
        console.log(err);
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Nome do destinatário inválido");
          case 2:
            return notification("error", "Instituição inválida.");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fDados = {
    title: "Novo token de cadastro",
    form: {
      usuarioNome: {
        label: "Nome do utilizador",
        type: "text",
        // space: 6,
        value: dados.usuarioNome,
        required: true,
      },
      instituicaoId: {
        label: "Instituição",
        space: 6,
        value: dados.instituicaoId,
        type: "select",
        emptyItem: true,
        array: {
          data: instituicoes,
          value: "id",
          desc: "nomeFantasia",
        },
        required: true,
      },
      expiracao: {
        type: "date",
        label: "Expira em",
        space: 6,
        value: dados.expiracao,
      },
    },

    submit: {
      label: "Salvar",
      action: salvar,
    },

    history,
    close: true,
  };

  return (
    <div>
      <Form formData={fDados} />
    </div>
  );
}
